export default {
  ALL: "Tous",
  ALL_EQUIPMENT: "Tous les équipements",
  PANELS: "Modules photovoltaïques",
  INVERTERS: "Onduleur(s)",
  INVERTERS_MONOPHASE: "Monophasés",
  INVERTERS_TRIPHASE_LTE_30KW: "Triphasés 0-30 kW",
  INVERTERS_TRIPHASE_GT_30KW: "Triphasés > Projets 30 kW",
  INVERTERS_HYBRID: "Hybride",
  INVERTERS_ACCESSORIES: "Accessoires onduleur",
  BATTERIES: "Batteries",
  WORKWEAR: "Workwear",
  DISCONNECTS: "Coffrets AC/DC",
  ACCESSORIES: "Accessoires",
  COMBINER_BOXES: "Boîtes de combinaison",
  MOUNTING_SYSTEMS: "Systèmes de fixation",
  SERVICE_PANELS: "Tableaux électriques",
  LOAD_CENTERS: "Disjoncteurs",
  DC_OPTIMISERS: "Optimiseurs DC",
  TILES: "Tuiles solaires",
  SMALL_PRODUCER_ADMINISTRATION: "Résidentiel (< 36 kVa)",
  LARGE_PRODUCER_ADMINISTRATION: "Tertiaire (+ 36 kVa)",
  CONSUEL_ADMINISTRATION: "Consuel",
  GRID_CONNECTION_ADMINISTRATION: "Raccordement",
  MAYOR_ADMINISTRATION: "Urbanisme",
  FEATURED_ADMINISTRATION: "Featured administration",
  FEATURED_HARDWARE: "Featured hardware",
  FEATURED: "Featured",
  PERSONALIZED_OFFER: "Offres personnalisées",
  FOR_YOU: "Pour vous",
  "secondary-menubar": {
    PANELS: "Panneaux solaires",
    INVERTERS: "Onduleurs",
    MICROINVERTERS: "Micro-onduleurs",
    DC_OPTIMISERS: "Optimiseurs",
    BATTERIES: "Stockage d'énergie",
    WORKWEAR: "Workwear",
    DISCONNECTS: "Coffrets AC/DC",
    ACCESSORIES: "Accessoires",
    COMBINER_BOXES: "Boîtes de combinaison",
    SHOP_ALL: "Tout acheter",
    AVAILABLE: "Disponible",
    PCS: "pièces",
    FROM: "À partir de",
    OUT_OF_STOCK: "En rupture de stock",
    NO_PRODUCTS_FOUND: "Aucun produit trouvé",
    SHOW_ALL_PRODUCTS: "Voir tous les produits",
    TOP_BRANDS: "Meilleures marques",
    BY_RATING_STC: "Par puissance",
    BY_TECHNOLOGY: "Par technologie",
  },
}
